import { useEffect, useMemo, useState } from 'react';

import CloseIcon from './icons/CloseIcon';
import { AiChatbotCard } from './AiChatbotCard';
import { SplitPaymentToggle } from './SplitPaymentToggle';
// import { Templately } from './Templately';
import { WpdCheckoutSubProductList } from './WpdCheckoutSubProductList';
import {
	lifetimeProducts,
	monthlyProducts,
	yearlyProducts,
	appSumoTier3Bundle,
	APPSUMO_EAE_TIER_3_BUNDLE_ID,
	AGENCY_BUNDLE_ID,
} from '../../../utils/AgencyBundleProducts';

const PerMonth = ({ price }) => {
	return (
		<>
			${price}
			<span
				style={{
					fontSize: '12px',
					fontWeight: 500,
					color: '#5D6776',
				}}
			>
				/mo
			</span>
		</>
	);
};

export function ProductCard({
	cartIndex,
	product,
	removeFromCart,
	isAgencyLifetime,
	cartHasAgencyBundle,
	cartHasAppSumoBundle,
	processingCheckout,
	renewalDiscount,
	monthFree,
	showFree,
	...restProps
}) {
	const [bundleProducts, setBundleProducts] = useState(undefined);

	useEffect(() => {
		if (cartHasAgencyBundle) {
			if (parseInt(cartHasAgencyBundle.id) === AGENCY_BUNDLE_ID) {
				setBundleProducts(
					getAgencyBundleProducts(
						parseInt(cartHasAgencyBundle.options.price_id)
					)
				);
			} else {
				setBundleProducts(undefined);
			}
		}
	}, [cartHasAgencyBundle]);

	useEffect(() => {
		if (cartHasAppSumoBundle) {
			if (
				parseInt(cartHasAppSumoBundle.id) ===
				APPSUMO_EAE_TIER_3_BUNDLE_ID
			) {
				setBundleProducts(appSumoTier3Bundle);
			} else {
				setBundleProducts(undefined);
			}
		}
	}, [cartHasAppSumoBundle]);

	const getAgencyBundleProducts = priceId => {
		switch (parseInt(priceId)) {
			case 1:
				return yearlyProducts;
			case 2:
				return lifetimeProducts;
			case 5:
				return monthlyProducts;
			default:
				return lifetimeProducts;
		}
	};

	const itsEAE = useMemo(() => {
		const priceId = +product?.item_number?.options?.price_id;
		const productId = +product?.id;
		return productId === 4372 && (priceId === 1 || priceId === 3);
	}, [product]);

	// const isLifetimeProduct = product.item_number?.options?.recurring?.period === undefined;
	const isYearlyProduct =
		product.item_number?.options?.recurring?.period === 'year';
	const isMonthlyProduct =
		product.item_number?.options?.recurring?.period === 'month';

	const getPrice = item => {
		const itsEAE =
			+item?.id === 4372 &&
			(+item?.item_number?.options?.price_id === 1 ||
				+item?.item_number?.options?.price_id === 3);
		const eaePriceID = +item?.item_number?.options?.price_id;

		let times = item?.item_number?.options?.recurring?.times ?? 0;

		let originalItem = { ...item };
		item = { ...originalItem };

		if (times > 0) {
			item.item_price = item.item_price * times;
			item.price = item.item_price - +originalItem.discount * times;
			item.subtotal = item.item_price;
		}

		if (item.price && item.subtotal && item.price === item.subtotal) {
			if (itsEAE) {
				return eaePriceID === 1 ? (
					<PerMonth price="4.99" />
				) : (
					<PerMonth price="9.99" />
				);
			}

			return (+item.subtotal)?.toFixed(2);
		}

		if (itsEAE) {
			const subtotal = Math.trunc((+item?.subtotal / 12) * 100) / 100;
			const price = Math.trunc((+item?.price / 12) * 100) / 100;

			return (
				<>
					<span className="main-price">
						<PerMonth price={subtotal?.toFixed(2)} />
					</span>
					<span className="discounted-price">
						<PerMonth price={price?.toFixed(2)} />
					</span>
				</>
			);

			// return eaePriceID === 1 ? <PerMonth price="4.99" /> : <PerMonth price="9.99" />;
		}

		// (+item?.subtotal)?.toFixed(2) (Full Price)
		// (+item.price)?.toFixed(2)

		// return (+item?.subtotal)?.toFixed(2);

		return (
			<>
				<span className="main-price">
					$
					{typeof item?.subtotal === 'string'
						? item?.subtotal
						: item?.subtotal?.toFixed(2)}
				</span>
				<span className="discounted-price">
					$
					{typeof item?.price === 'string'
						? item?.price
						: item?.price?.toFixed(2)}
				</span>
			</>
		);
	};

	const is100PercentCouponApplied = useMemo(() => {
		if (!restProps.coupon) {
			return false;
		}

		return (
			restProps.coupon?.is_valid &&
			restProps.coupon?.type === 'percent' &&
			restProps.coupon?.amount === 100
		);
	}, [restProps.coupon]);

	const [isButtonActive, setIsButtonActive] = useState(false);

	const buttonToggle = () => {
		setIsButtonActive(!isButtonActive);
	};

	return (
		<>
			<div className="wp-checkout-flex wp-checkout-flex-center wp-checkout-flex-space-between wp-checkout-product-card">
				<div className="wp-checkout-flex wp-checkout-col-8 wp-checkout-flex-center">
					<div className="wp-checkout-product-card-logo">
						<img src={product?.item_number?.image} />
					</div>
					<div className="wp-checkout-product-card-header">
						<h3 className="wp-checkout-font-lg wp-checkout-product-card-title">
							{product.name}
						</h3>
						<p className="wp-checkout-font-sm wp-checkout-product-card-sub-title">
							<span className="product-card-sub-title-highlight">
								{product?.item_number?.price_name}
							</span>{' '}
							{isYearlyProduct &&
								'- Billed once per year until cancelled'}
							{isMonthlyProduct &&
								'- Billed once per month until cancelled'}
						</p>
					</div>
				</div>
				<div className="wp-checkout-flex wp-checkout-col-4 wp-checkout-flex-center wp-checkout-product-price-with-close">
					<h3 className="wp-checkout-font-lg wp-checkout-product-price">
						{getPrice(product)}
					</h3>
					<button
						className="wp-checkout-product-close"
						onClick={() => removeFromCart(cartIndex)}
						disabled={processingCheckout}
					>
						<CloseIcon />
					</button>
				</div>
			</div>
			{/* For BetterDocs Pro Only */}
			{342422 === +product?.id && (
				<AiChatbotCard
					index={'BetterDocsAIChatBot'}
					id={1882016}
					removeFromCart={removeFromCart}
					{...restProps}
				/>
			)}
			{/* For Agency Bundle Only */}
			{(AGENCY_BUNDLE_ID === +product?.id ||
				APPSUMO_EAE_TIER_3_BUNDLE_ID === +product?.id) && (
				<>
					<div className="wp-checkout-agency-bundle-btn-wrapper">
						<button
							className={`wp-checkout-font-sm wp-checkout-agency-bundle-btn ${isButtonActive ? 'active-button' : ''}`}
							onClick={buttonToggle}
						>
							<span>View All Products</span>
							<span className="wp-checkout-agency-bundle-btn-icon">
								<svg
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clipPath="url(#clip0_1888_6029)">
										<path
											d="M4 6L8 10L12 6"
											strokeWidth="1.5"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</g>
									<defs>
										<clipPath id="clip0_1888_6029">
											<rect
												width="16"
												height="16"
												fill="white"
											/>
										</clipPath>
									</defs>
								</svg>
							</span>
						</button>
					</div>

					<div
						className={`WpdCheckoutSubProductList-wrapper ${isButtonActive ? 'active-products' : ''}`}
					>
						<WpdCheckoutSubProductList
							product={product}
							bundleProducts={bundleProducts}
						/>
					</div>
				</>
			)}

			{isAgencyLifetime &&
				AGENCY_BUNDLE_ID === +product?.id &&
				!is100PercentCouponApplied && (
					<SplitPaymentToggle
						{...restProps}
						is100PercentCouponApplied={is100PercentCouponApplied}
						index={cartIndex}
						agencyBundle={cartHasAgencyBundle}
					/>
				)}
		</>
	);
}
